window.$ = require('jquery');
window.jQuery = window.$;
window.ScrollMagic = require('scrollmagic');
window.gsap = require('gsap/TweenLite');
require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap.js');

if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, 'assign', {
    value: function assign(target, varArgs) {
      // .length of function is 2
      'use strict';
      if (target == null) {
        // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) {
          // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}
var helpers = {
  openURLInWindow: function(url) {
    var windowOptions = 'scrollbars=yes,resizable=yes,toolbar=no,location=yes';
    var width = 550,
      height = 420,
      winHeight = screen.height,
      winWidth = screen.width;
    var left = Math.round(winWidth / 2 - width / 2);
    var top = 0;
    if (winHeight > height) {
      top = Math.round(winHeight / 2 - height / 2);
    }
    window.open(url, 'intent', windowOptions + ',width=' + width + ',height=' + height + ',left=' + left + ',top=' + top);
  },

  setBodyScrolling: function(allowScrolling) {
    if (allowScrolling) {
      $('body').removeClass('no-scroll-mobile');
    } else {
      $('body').addClass('no-scroll-mobile');
    }
  },

  kpiRefreshChart: function(index) {
    if (kpiState.currentLoadingIndex === index) {
      return;
    }
    kpiState.currentLoadingIndex = index;
    var chartContainer = $('#dynamic_chart_' + index);
    var chartContainerURL = chartContainer.data('kpi-url');
    var dataLoaded = chartContainer.data('data-loaded') === 'true';

    var loadData = function() {
      var storedIndex = index;
      $.ajax(chartContainerURL).then(function(result) {
        try {
          // new field on the ajax call result set (report config)
          result.displayTextRendering = helpers.kpiChartSumOfLabels; // this would generate a sum for all
          result.locale = helpers.reportLanguage();
          chartContainer.data('data-loaded', 'true');
          chartContainer.ejChart(result);
        } catch (error) {
          console.error(error);
        }
      });
    };

    // uncomment me if needed
    if (chartContainerURL && !dataLoaded) {
      setTimeout(loadData, 600);
    }
  },

  reportLanguage: function() {
    try {
      var path = window.location.pathname.split('/')[1];
      var locale = path !== 'en' ? path + '-CH' : 'en-US';
      return locale;
    } catch (error) {
      console.error('Unable to get the current report langauge setting de');
      return 'de-CH';
    }
  },

  kpiChartSumOfLabels: function(sender) {
    // check the length of series, if there is only one -> always return the one
    if (sender.model.series.length === 1) {
      // no decimal values, this works
      // var newValue = parseInt(sender.data.text.replace(/[,'.]/g, '').trim(), 10);
      // sender.data.text = newValue.toLocaleString(helpers.reportLanguage());
      var value = 0;
      for (var i = 0; i < sender.model.series.length; i++) {
        value += sender.model.series[i].points[sender.data.pointIndex].y;
      }
      sender.data.location.y = sender.data.location.y - 5;
      sender.data.text = value.toLocaleString(helpers.reportLanguage());

      return;
    }

    // check if all series elements are visible
    var allItemsVisible =
      sender.model.series.filter(function(seriesElement, index, all) {
        return seriesElement.visibility === 'visible';
      }).length === sender.model.series.length;

    if (!allItemsVisible) {
      // show only the current stack value
      return;
    }

    // if all elements are visible calculate the count
    if (sender.data.seriesIndex === sender.model.series.length - 1 && sender.model.series.length > 1) {
      var value = 0;
      for (var i = 0; i < sender.model.series.length; i++) {
        value += sender.model.series[i].points[sender.data.pointIndex].y;
      }
      sender.data.location.y = sender.data.location.y - 5;
      sender.data.text = value.toLocaleString(helpers.reportLanguage());
    } else {
      sender.data.text = '';
    }
  }
};

var kpiState = {
  currentLoadingIndex: undefined
};

var setup = {
  mobileNavigation: function() {
    var openNavigationOverlay = function() {
      $('.landing__page').toggleClass('navigation-second-shown');
      helpers.setBodyScrolling(false);
    };

    var closeNavigationOverlay = function() {
      $('.landing__page').toggleClass('navigation-second-shown');
      helpers.setBodyScrolling(true);
    };

    $('#mobile-navigation-second-menu-button').click(openNavigationOverlay);
    $('#mobile-navigation-second-menu-close-button').click(closeNavigationOverlay);
    $('.navigation--employees a').click(closeNavigationOverlay);
  },

  video: function() {
    $('.video__play__trigger').click(function() {
      var videoOverlayId = $(this).data('video-overlay-id');
      $('#' + videoOverlayId).fadeIn(function() {
        videojs('video-' + videoOverlayId).play();
      });
      $('body').addClass('no-scroll');
    });
    $('.video__close__icon').click(function() {
      var videoOverlayId = $(this).data('video-overlay-id');
      videojs('video-' + videoOverlayId).pause();
      $('#' + videoOverlayId).fadeOut();
      $('body').removeClass('no-scroll');
    });
  },

  languageSelector: function() {
    $('.language__selector').click(function() {
      $('#lp-language-submenu').toggle();
    });
    $('#language-selector-mobile').click(function(event) {
      event.preventDefault();
      $('.landing__page').addClass('language-overlay-shown');
    });
    $('#language-overlay-close-button').click(function() {
      $('.landing__page').removeClass('language-overlay-shown');
    });
  },

  sharingLinks: function() {
    var sharingEnabledClasses = ['.icon-font-facebook', '.icon-font-twitter', '.icon-font-xing', '.icon-font-linkedin'];
    var setupJqueryClick = function(className) {
      $(className)
        .parent()
        .on('click', function(event) {
          event.preventDefault();
          var url =
            $(event.target)
              .parent()
              .attr('href') || $(event.target).attr('href');
          helpers.openURLInWindow(url);
        });
    };
    sharingEnabledClasses.forEach(function(classToRegister, index, all) {
      setupJqueryClick(classToRegister);
    });
  },

  kpiOpenClose: function() {
    var closeKPI = function(event) {
      $('.kpi_modal').toggleClass('shown');
      $('.kpi_modal .modal__overlay__content').toggleClass('shown');

      $('body').removeClass('no-scroll');
      document.onkeydown = null;
      kpiState.currentLoadingIndex = undefined;
    };

    $('.kpi__box').on('click', function(event) {
      $('body').addClass('no-scroll');
      var kpiIndex = $(event.currentTarget).attr('data-kpi-overlay');
      var owl = $('#kpi-owl-carousel');
      owl.trigger('resize.owl.carousel');
      owl.trigger('to.owl.carousel', [kpiIndex, 0, true]);
      $('.kpi_modal').toggleClass('shown');
      setTimeout(function() {
        $('.kpi_modal .modal__overlay__content').toggleClass('shown');
      }, 20);

      // insert esc key catch
      document.onkeydown = function(evt) {
        evt = evt || window.event;
        if (evt.keyCode === 27) {
          // escape
          closeKPI(event);
        } else if (evt.keyCode === 37) {
          // left arrow
          $('#mobile-carousel-nav-left').click();
        } else if (evt.keyCode === 39) {
          // right arrow
          $('#mobile-carousel-nav-right').click();
        }
      };
    });

    var closeButton = $('.kpi__close__icon, #mobile-carousel-nav-close');
    closeButton.on('click', closeKPI);
  },

  kpiCarousel: function() {
    if (!$().owlCarousel) {
      return;
    }

    var carousel = $('#kpi-owl-carousel');
    var refresh = function(event) {
      var index = event.item.index;

      var leftButtonEnabled = index !== 0;
      var rightButtonEnabled = index !== 7;

      if (leftButtonEnabled) {
        $('.desktop_nav_left, #mobile-carousel-nav-left').removeClass('disabled');
      } else {
        $('.desktop_nav_left, #mobile-carousel-nav-left').addClass('disabled');
      }

      if (rightButtonEnabled) {
        $('.desktop_nav_right, #mobile-carousel-nav-right').removeClass('disabled');
      } else {
        $('.desktop_nav_right, #mobile-carousel-nav-right').addClass('disabled');
      }

      helpers.kpiRefreshChart(index);
    };
    carousel.owlCarousel({ items: 1, loop: false, center: true });
    carousel.on('changed.owl.carousel', refresh);

    $('#mobile-carousel-nav-left, .desktop_nav_left').click(function() {
      var owl = $('#kpi-owl-carousel');
      owl.trigger('prev.owl.carousel');
    });
    $('#mobile-carousel-nav-right, .desktop_nav_right').click(function() {
      var owl = $('#kpi-owl-carousel');
      owl.trigger('next.owl.carousel');
    });
  },

  storyItems: function() {
    $('.stories__item').click(function(event) {
      event.preventDefault();
      var href = $(event.currentTarget)
        .find('.link')
        .first()
        .attr('href');
      window.location.assign(href);
    });
  },

  reavealAnimations: function() {
    if (!$('body').hasClass('index')) {
      return;
    }

    var controller = new ScrollMagic.Controller();

    var fromOptionsMultipleItems = { scale: 1, opacity: 0, y: 20 };
    var toOptionsMultipleItems = { opacity: 1, scale: 1, y: 0, delay: 0.2, ease: Linear.easeOut };

    var fromOptionsSingleItem = {
      scale: 1,
      opacity: 0,
      y: 20,
      x: 0,
      rotationX: '-20deg',
      transformPerspective: 800
    };
    var toOptionsSingleItem = { opacity: 1, scale: 1, y: 0, x: 0, rotationX: '0deg', ease: Linear.easeOut, delay: 0.3 };
    var singleDuration = 0.5;

    var heroOptions = Object.assign({}, toOptionsSingleItem, { delay: 0.6 });
    var stagger_hero = TweenMax.fromTo('.hero .box', singleDuration, fromOptionsSingleItem, heroOptions);
    var hero_scene = new ScrollMagic.Scene({ triggerElement: '.hero', reverse: false }).setTween(stagger_hero);

    var stagger_kpis = TweenMax.staggerFromTo('.kpis .kpi__box__wrapper', 0.3, fromOptionsMultipleItems, toOptionsMultipleItems, 0.1);
    var kpis_scene = new ScrollMagic.Scene({ triggerElement: '.kpis', reverse: false, offset: -200 }).setTween(stagger_kpis);

    var stagger_shareholder = TweenMax.fromTo('.shareholder .box', singleDuration, fromOptionsSingleItem, toOptionsSingleItem);
    var shareholder_scene = new ScrollMagic.Scene({ triggerElement: '.shareholder', reverse: false, offset: -200 }).setTween(
      stagger_shareholder
    );

    var stagger_stories = TweenMax.staggerFromTo('.stories .stories__item', 0.3, fromOptionsMultipleItems, toOptionsMultipleItems, 0.2);
    var stories_scene = new ScrollMagic.Scene({ triggerElement: '.stories', reverse: false, offset: -200 }).setTween(stagger_stories);

    var stagger_sustainability = TweenMax.fromTo('.sustainability .box', singleDuration, fromOptionsSingleItem, toOptionsSingleItem);
    var sustainability_scene = new ScrollMagic.Scene({ triggerElement: '.sustainability', reverse: false, offset: -100 }).setTween(
      stagger_sustainability
    );

    var stagger_share = TweenMax.staggerFromTo('.shares a', 0.3, fromOptionsMultipleItems, toOptionsMultipleItems, 0.1);
    var share_scene = new ScrollMagic.Scene({ triggerElement: '.share', reverse: false, offset: -200 }).setTween(stagger_share);

    controller.addScene([hero_scene, kpis_scene, shareholder_scene, stories_scene, sustainability_scene, share_scene]);
  }
};

window.onload = function() {
  setup.mobileNavigation();
  setup.languageSelector();
  setup.video();
  setup.storyItems();
  setup.reavealAnimations();
  setup.sharingLinks();
  setup.kpiCarousel();
  setup.kpiOpenClose();
};
